import { render, staticRenderFns } from "./insurance-provider-information.vue?vue&type=template&id=3abef5c7&"
import script from "./insurance-provider-information.vue?vue&type=script&lang=js&"
export * from "./insurance-provider-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports